export var FilterItemType;

(function (FilterItemType) {
  FilterItemType["Input"] = "input";
  FilterItemType["Select"] = "select";
  FilterItemType["DatePicker"] = "datepicker";
  FilterItemType["MultiCascader"] = "multiCascader";
  FilterItemType["Custom"] = "custom";
})(FilterItemType || (FilterItemType = {}));